import { EditorAuth } from 'easy-email-pro-core';
import { EditorCore } from 'easy-email-pro-core';

/**
 * Compile an EasyEmail Pro `content` tree into responsive HTML using the same
 * pipeline the editor's Save action runs (`EditorCore.toMJML` → mjml-browser).
 *
 * Used by the starter-template picker so the preview reflects exactly what the
 * editor would output — never stale, even if the starter JSON predates the
 * current MJML compiler.
 */
export const renderEmailHtml = async (content: any): Promise<string> => {
  if (!content) return '';
  await EditorAuth.auth(process.env.STRAPI_ADMIN_EASYEMAIL_PRO_CLIENT_ID!)
  const mjmlStr = EditorCore.toMJML({
    element: content,
    mode: 'production',
    beautify: false,
  });
  const { default: mjml2html } = await import('mjml-browser');
  const { html } = mjml2html(mjmlStr, { validationLevel: 'soft' });
  return html;
};
